import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Sidebar from "./Sidebar";

import CategoryDashboard from "./CategoryDashboard";
import ProductManagement from "./ProductManagement";
import Dashboard from "./Dashboard";
// import { Button } from "react-bootstrap";


const AdminDashboard = () => {
  const [activeTab, setActiveTab] = useState("dashboard");

  return (
    <div className="d-flex flex-column flex-md-row">
      {/* Sidebar - Visible only on larger screens */}
      <div className="d-none d-md-block">
        <Sidebar setActiveTab={setActiveTab} />
      </div>

      {/* Mobile Navigation Buttons */}
      <div className="d-md-none d-flex justify-content-around p-2 bg-light border-top fixed-bottom">
        <button size="sm" variant="primary" onClick={() => setActiveTab("dashboard")}>
          Dashboard
        </button>
        <button size="sm" variant="secondary" onClick={() => setActiveTab("manageCategory")}>
          Categories
        </button>
        <button size="sm" variant="success" onClick={() => setActiveTab("manageProduct")}>
          Products
        </button>
      </div>

      {/* Main Content */}
      <div className="flex-grow-1 p-3" style={{ minHeight: "100vh" }}>
        {activeTab === "dashboard" && <Dashboard />}
        {activeTab === "manageCategory" && <CategoryDashboard />}
        {activeTab === "manageProduct" && <ProductManagement />}
      </div>
    </div>
  );
};

export default AdminDashboard;
